import React from "react"
import { Match } from "@gatsbyjs/reach-router"
import DownloadPageContent from "../components/DownloadPageContent"
import FrontPageMeta from "../components/FrontPageMeta"

const DownloadPage = () => {
  return (
    <Match path="/:lang/download/:id">
      {props => <DownloadPageContent shortUrl={props.match?.id} />}
    </Match>
  )
}

export const Head = ({ pageContext }) => (
  <FrontPageMeta language={pageContext.language} />
)

export default DownloadPage
